"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JEVMBlockchain = void 0;
const ethers_1 = require("ethers");
const transaction_1 = require("../transaction");
const utils_1 = require("../utils");
const chain_1 = require("./chain");
const constants_1 = require("./constants");
const solidity_1 = require("./solidity");
const vm_1 = require("./vm");
class JEVMBlockchain extends chain_1.AbstractBlockchain {
    asset;
    chainId;
    baseFee;
    ethProvider;
    jrc20Assets;
    wrappedAsset;
    contractManager = new solidity_1.ContractManager();
    constructor(name, id, asset, chainId, baseFee, nodeAddress, aliases, registeredAssets = [], jrc20Assets = [], wrappedAsset) {
        super(name, id, new vm_1.ChainVM(constants_1.JEVM_ID, vm_1.VMType.EVM, vm_1.VMWalletType.Nonce, constants_1.EVM_HD_PATH), asset, aliases, registeredAssets);
        this.asset = asset;
        this.chainId = chainId;
        this.baseFee = baseFee;
        this.ethProvider = new ethers_1.ethers.JsonRpcProvider(`${nodeAddress}/ext/bc/${id}/rpc`);
        this.jrc20Assets = jrc20Assets;
        this.wrappedAsset = wrappedAsset;
        if (typeof wrappedAsset !== 'undefined') {
            this.addRegisteredAsset(wrappedAsset);
        }
        this.contractManager.registerHandler(new solidity_1.ERC20TokenHandler(this.ethProvider));
    }
    async getContractTransactionData(provider, assetId, to, amount) {
        // could rather use contract manager but it would require one extra network call
        // we avoid it if the asset is already registered
        const asset = await this.getAsset(provider, assetId);
        if (constants_1.EVMTransferables.includes(asset.type)) {
            return this.contractManager.getTransferData(this.ethProvider, assetId, to, amount);
        }
        return constants_1.EmptyCallData;
    }
    async fetchAsset(provider, assetId) {
        if ((0, utils_1.isContractAddress)(assetId)) {
            const handler = await this.contractManager.getHandler(assetId);
            if (handler === null) {
                throw new utils_1.ChainError(`contract address ${assetId} does not implement a compatible interface`);
            }
            return await handler.queryTokenData(assetId);
        }
        return await (0, utils_1.fetchJNT)(provider, assetId);
    }
    validateAddress(address) {
        return ethers_1.ethers.isAddress(address);
    }
    async queryBalance(api, address, assetId) {
        // native asset
        if (assetId === this.assetId) {
            return await api.eth_getBalance(address, 'pending');
        }
        // jnt asset
        if (transaction_1.AssetId.validate(assetId)) {
            return await api.eth_getAssetBalance(address, 'pending', assetId);
        }
        // from here should only be solidity smart contract
        if (!(0, utils_1.isContractAddress)(assetId)) {
            throw new utils_1.ChainError(`cannot query balance of invalid asset id ${assetId}`);
        }
        return await this.contractManager.balanceOf(this.ethProvider, assetId, address);
    }
}
exports.JEVMBlockchain = JEVMBlockchain;
